import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS } from "@/shared";
import { useFetchOrdenTrabajos, useGetAgendamiento } from "@/shared/actions/erp";
import { useCheckPermissions, useLoaders } from "@/shared/hooks";
import { Navigate, useParams } from "react-router-dom";
import SaveAgendamientoPyL from "../../shared/components/SaveAgendamiento/SaveAgendamientoPyL";

export type UpdateAgendamientoPageProps = {};

const UpdateAgendamientoPage: React.FC<UpdateAgendamientoPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_agendamiento);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { id } = useParams();
  const { data, isLoading } = useGetAgendamiento(id!);
  // Esperar a que el fetch de la OT termine antes de renderizar el form:
  // el onSuccess del Recoordinar dispara un PUT a /orden-trabajo/<id>, y si
  // dataOT todavia no cargo, ese id sale como undefined y el backend
  // responde 500 "undefined no es un UUID valido". La primera vez fallaba
  // por race condition, la segunda funcionaba por cache de React Query.
  const { data: dataOT, isLoading: isLoadingOT, isFetching: isFetchingOT } =
    useFetchOrdenTrabajos({
      enabled: !!data?.data?.codigo,
      params: {
        agendamiento: data?.data?.codigo,
      },
    });
  useLoaders(isLoading || isLoadingOT || isFetchingOT);

  if (isLoading || isLoadingOT || isFetchingOT) return null;
  if (!data?.data?.id_agendamiento)
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SaveAgendamientoPyL
      title={"Recordinar Agendamiento"}
      agendamiento={data.data}
      dataOT={dataOT?.data?.data?.[0]}
    />
  );
};

export default UpdateAgendamientoPage;
